import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { theme } from "ant-design-vue";

export const THEME_STATE_LOCAL_STORAGE_KEY = "baskit_front_theme";

export const useThemeStore = defineStore("themeStore", () => {
  const isDarkTheme = ref<boolean>(false);

  const currentThemeAlgorithm = computed(() =>
    isDarkTheme.value ? theme.darkAlgorithm : theme.defaultAlgorithm,
  );

  const setDarkTheme = (isDark: boolean) => {
    isDarkTheme.value = isDark;

    saveThemeStateInLocalStorage();
  };

  const saveThemeStateInLocalStorage = () => {
    localStorage.setItem(
      THEME_STATE_LOCAL_STORAGE_KEY,
      JSON.stringify({ isDarkTheme: isDarkTheme.value }),
    );
  };

  const loadThemeStateFromLocalStorage = () => {
    const themeStringify = localStorage.getItem(THEME_STATE_LOCAL_STORAGE_KEY);

    if (themeStringify) {
      const theme = JSON.parse(themeStringify);

      setDarkTheme(theme.isDarkTheme);
    }
  };

  const toggleTheme = () => {
    setDarkTheme(!isDarkTheme.value);
  };

  loadThemeStateFromLocalStorage();

  return {
    currentThemeAlgorithm,
    isDarkTheme,
    setDarkTheme,
    toggleTheme,
  };
});
